<div id="empty-loans-card" class="card-base flex flex-col gap-6 items-center justify-center px-8 py-6">
  <p id="empty-loans-message" class="font-dm font-normal text-base leading-6 text-center text-ld-neutral-700 m-0">
    {{ message() }}
  </p>

  <button id="empty-loans-link-loan-btn" type="button" class="btn-primary-ld-purple" (click)="onLinkLoan()">
    {{ linkLoanLabel() }}
  </button>
</div>
